import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import { ToastContainer, toast } from 'react-toastify';

function SettingMaster(props) {
  const [states, setStates] = useState([]);
  const [SettingCode, setSettingCode] = useState('');
  const [SettingDesc1, setSettingDesc1] = useState('');         
  const [SettingValue1, setSettingValue1] = useState('');
  const [SettingDesc2, setSettingDesc2] = useState('');
  const [SettingValue2, setSettingValue2] = useState('');
  const [SettingDesc3, setSettingDesc3] = useState('');
  const [SettingValue3, setSettingValue3] = useState('');

  const [UserID, setUserID] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [formMode, setFormMode] = useState('add');
  const [editStateCode, setEditStateCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [settingMasterEntries, setSettingMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  


  useEffect(() => {
    fetchSettingMaster();
  }, []);

  const fetchSettingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/setting');
      setSettingMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setSettingCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.SettingCode > maxEntryNo) {
  maxEntryNo = entry.SettingCode;
  }
  }
  return maxEntryNo;
  };

  const addSetting = async () => {
    if ((!props.canAdd)) {
              const action = "Save";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
    try {
      await axios.post('https://www.wingap.net.in/api/setting', {
        SettingCode: SettingCode,
        SettingDesc1: SettingDesc1,
        SettingValue1: SettingValue1,
        SettingDesc2: SettingDesc2,
        SettingValue2: SettingValue2,
        SettingDesc3: SettingDesc3,
        SettingValue3: SettingValue3,
        UserID: props.name,
      });
      fetchSettingMaster();
      setSettingCode('');
      setSettingDesc1('');
      setSettingValue1('');
      setSettingDesc2('');
      setSettingValue2('');
      setSettingDesc3('');
      setSettingValue3('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateSetting = async (SettingCode) => {
    if ((!props.canEdit)) {
              const action = "Update";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
    try {
      await axios.put(`https://www.wingap.net.in/api/setting/${SettingCode}`, {
        SettingCode: SettingCode,
        SettingDesc1: SettingDesc1,
        SettingValue1: SettingValue1,
        SettingDesc2: SettingDesc2,
        SettingValue2: SettingValue2,
        SettingDesc3: SettingDesc3,
        SettingValue3: SettingValue3,
        UserID: props.name,
      });
      fetchSettingMaster();
      setSettingCode('');
      setSettingDesc1('');
      setSettingValue1('');
      setSettingDesc2('');
      setSettingValue2('');
      setSettingDesc3('');
      setSettingValue3('');
      setUserID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteSetting(deleteEntryNo.SettingCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteSetting = async (SettingCode) => {
    if (!props.canDelete) {
              toast.error("You do not have permission to Delete.", { autoClose: 800 });
              return;
            }
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/setting/${SettingCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchSettingMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (state) =>{
    setFormMode('edit');
    setSettingCode(state.SettingCode);
    setSettingDesc1 (state.SettingDesc1);
    setSettingValue1 (state.SettingValue1);
    setSettingDesc2 (state.SettingDesc2);
    setSettingValue2 (state.SettingValue2);
    setSettingDesc3 (state.SettingDesc3);
    setSettingValue3 (state.SettingValue3);
    setUserID(state.UserID);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = states.filter((state) => {
      const StateCode = state.StateCode.toString().toLowerCase();
      const StateName = state.StateName.toString().toLowerCase();

      return (
        StateCode.includes(searchQuery.toLowerCase()) ||
        StateName.includes(searchQuery.toLowerCase())
      );
    });

    setSettingMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, states]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setStates(states);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditStateCode('');
      setSettingCode('');
      setSettingDesc1('');
      setSettingValue1('');
      setSettingDesc2('');
      setSettingValue2('');
      setSettingDesc3('');
      setSettingValue3('');
      setUserID('');
      fetchSettingMaster();
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "StateData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <ToastContainer/>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Setting Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingCode</label>
            <input
              type="text"
              value={SettingCode}
              readOnly
              placeholder="SettingCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingDesc1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingDesc1</label>
            <input
              type="text"
              value={SettingDesc1}
              onChange={(e) => setSettingDesc1(e.target.value)}
              placeholder="SettingDesc1"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingValue1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingValue1</label>
            <input
              type="text"
              value={SettingValue1}
              onChange={(e) => setSettingValue1(e.target.value)}
              placeholder="SettingValue1"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingDesc2" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingDesc2</label>
            <input
              type="text"
              value={SettingDesc2}
              onChange={(e) => setSettingDesc2(e.target.value)}
              placeholder="SettingDesc2"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingValue2" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingValue2</label>
            <input
              type="text"
              value={SettingValue2}
              onChange={(e) => setSettingValue2(e.target.value)}
              placeholder="SettingValue2"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingDesc3" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingDesc3</label>
            <input
              type="text"
              value={SettingDesc3}
              onChange={(e) => setSettingDesc3(e.target.value)}
              placeholder="SettingDesc3"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SettingValue3" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SettingValue3</label>
            <input
              type="text"
              value={SettingValue3}
              onChange={(e) => setSettingValue3(e.target.value)}
              placeholder="SettingValue3"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UserID" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UserID
            </label>
            <input
              type="text"
              value={UserID}
              readOnly
              onChange={(e) => setUserID(e.target.value)}
              placeholder="UserID"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addSetting : () => updateSetting(SettingCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>
      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingDesc1
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingValue1
                </th> <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingDesc2
                </th> <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingValue2
                </th> <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingDesc3
                </th> <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SettingValue3
                </th> 
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {settingMasterEntries.map((state) => (
                <tr key={state.SettingCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingDesc1}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingValue1}</td>

                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingDesc2}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingValue2}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingDesc3}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{state.SettingValue3}</td>

                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(state)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({SettingCode: state.SettingCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default SettingMaster;
